module.exports = __webpack_public_path__ + "static/media/3.1bd659f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/grodno/3.jpg
// module id = 225
// module chunks = 0